import React from 'react';
import Form from '../Components/Form';
import raqueteImage from '../Assets/raquete.png';
import '../Styles/Sections/sorteio.css';

const Sorteio = () => {
  return (
    <section className="sorteio-section" id="sorteio">
      <div className="container">
        <div className="sorteio-wrapper">
          <div className="sorteio-header">
            <div className="header-badge">
              SORTEIO EXCLUSIVO
            </div>
            <h1 className="sorteio-title">
              GANHE UMA RAQUETE
              <span className="highlight">POISON BEE 2025</span>
            </h1>
            <p className="sorteio-subtitle">
              Edição especial assinada por Gigio Cariani
            </p>
          </div>

          <div className="main-content">
            <div className="left-content">
              <div className="raquette-container">
                <img
                  src={raqueteImage}
                  alt="Raquete BeeTrue POISON BEE 2025"
                  className="raquette-image"
                />
                <div className="raquette-info">
                  <div className="brand-logo">
                    <span className="brand-text">BeeTrue</span>
                  </div>
                  <h2 className="raquette-model">POISON BEE</h2>
                  <p className="raquette-signature">Gigio Cariani Signature</p>
                </div>
              </div>

              <div className="features-list">
                <div className="feature-item">
                  <span className="feature-icon bolt"></span>
                  <div className="feature-text">
                    <h4>Potência Extrema</h4>
                    <p>Máximo desempenho em cada jogada</p>
                  </div>
                </div>

                <div className="feature-item">
                  <span className="feature-icon target"></span>
                  <div className="feature-text">
                    <h4>Precisão Cirúrgica</h4>
                    <p>Controle absoluto da bola</p>
                  </div>
                </div>

                <div className="feature-item">
                  <span className="feature-icon trophy"></span>
                  <div className="feature-text">
                    <h4>Tecnologia Pro</h4>
                    <p>Materiais de última geração</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="right-content">
              <div className="form-container">
                <div className="form-header">
                  <h3>PARTICIPE AGORA</h3>
                  <p>Preencha o formulário e concorra à raquete exclusiva</p>
                </div>
                <Form />

                <div className="event-info">
                  <div className="event-detail">
                    <span className="event-icon calendar"></span>
                    <div className="event-text">
                      <strong>Data do Sorteio</strong>
                      <span>Domingo, 30 de Novembro</span>
                    </div>
                  </div>

                  <div className="event-detail">
                    <span className="event-icon location"></span>
                    <div className="event-text">
                      <strong>Local</strong>
                      <span>Final do Mundial Beach Tennis - Campo Mourão</span>
                    </div>
                  </div>

                  <div className="event-detail">
                    <span className="event-icon clock"></span>
                    <div className="event-text">
                      <strong>Prazo de Resposta</strong>
                      <span>24 horas após contato</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="rules-section">
            <h4>Regras do Sorteio</h4>
            <ul>
              <li>Preencha todos os campos obrigatórios</li>
              <li>Apenas uma participação por CPF</li>
              <li>O ganhador será contatado por telefone/WhatsApp</li>
              <li>Presença obrigatória no dia do sorteio</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sorteio;